import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as React from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { Button, SelectChangeEvent } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Formik } from "formik";
import createCache from "@emotion/cache";
import { createStyles, makeStyles } from "@material-ui/core";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import FormControl from "@mui/material/FormControl";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useEffect, useState } from "react";
import useCollapse from "react-collapsed";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import {
  ApiResultModel,
  ColumnModel,
  PageInfoModel,
} from "../../models/common.model";
import {
  Filter,
  GetPaymentHistoryRequest,
  GetPaymentHistoryResponse,
} from "../../models/supplierPayment.model";
import {
  ExportGetRegisterLoans,
  GetRegisterLoans,
} from "../../services/cartable.service";
import {
  FilterFinder,
  GetCustomerRegistrationInfoRequest,
  GetLoanDetailResponse,
  GetLoanRegistrationWizardInfoResponse,
  GetLoansRequest,
} from "../../models/loan.model";
import { GetStatusResponse } from "../../models/basicInformation.model";
import {
  CURRENT_STATUS_STEPPERCMP,
  CUSTOMER_INFO,
  EXISTING_LOANREQUEST,
  HAS_REGISTER_REQUEST,
  LOAN_ID,
  LOAN_REQUEST_INFO_STEPPERCMP,
  LOAN_REQUEST_SOURCE,
  LOAN_REQUEST_STATUS,
  LOAN_TEMPLATES,
  LOAN_TEMPLATE_INFOS,
  REFRENCE_KEY,
  SUPPLIER_SETTLEMENT_STATUS,
  SUPPLIER_UESR,
  TABLE_FILTER,
  TABLE_FILTER_PAYMENT,
  TABLE_FILTER_REGISTER,
  TABS_STEPPERCMP,
  TEST,
} from "../../config/cacheKey";
import {
  GetLoanRequestSources,
  GetLoanTemplates,
  GetSupplierSettlementStatus,
  GetSupplierUsers,
  getLoanRequestStatus,
} from "../../services/basicInformation.service";
import {
  getCustomerRegistrationInfo,
  getLoanRegistrationWizardInfo,
} from "../../services/loan.service";
import ChipCmp from "../../components/chip/chipCmp";
import DatePickerComponents from "../../components/datePicker/DatePickerComponents";
import {
  GetInProgressPayments,
  GetPaymentHistory,
} from "../../services/supplierPayment.service";

const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: muiSelected,
      },
    },
  })
);

const nextIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Next.png" />
  );
};
const previusIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Previous.png" />
  );
};

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const columns: readonly ColumnModel[] = [
  { id: "supplierUser", label: "کاربر درخواست دهنده" },
  { id: "requestDate_Persian", label: "تاریخ درخواست" },
  {
    id: "settlementAmount",
    label: "مبلغ تسویه (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },

  {
    id: "supplierIban",
    label: "شماره شبا ",
  },
  {
    id: "status",
    label: "وضعیت",
  },
  {
    id: "description",
    label: "توضیحات",
  },
];
let muiSelected: any;
export default function DuringPaymentTableCmp(props: any) {
  const queryClient = useQueryClient();
  const classes = useStyles();
  const history = useHistory<{
    from: string;
    id: string;
    pageNumber: number;
    clickOnBack: boolean;
  }>();
  const jsonFile = useSelector((state: any) => state.style);
  muiSelected = jsonFile?.muiSelected;
  const [selectedRow, setSelectedRow] = useState(undefined);
  const [data, setData] = React.useState<GetPaymentHistoryResponse[]>([]);

  const [loanRequestOptions, setLoanRequestOptions] = React.useState<
    GetStatusResponse[]
  >([]);
  // const [
  //     supplierSettlementOptions,
  //     setSupplierSettlementOptions,
  // ] = React.useState<GetStatusResponse[]>([]);
  // const [
  //     loanRequestSourceOptions,
  //     setLoanRequestSourceOptions,
  // ] = React.useState<GetStatusResponse[]>([]);
  // const [loanTemplateOptions, setLoanTemplateOptions] = React.useState<
  //     GetStatusResponse[]
  // >([]);
  // const [supplierUserOptions, setSupplierUserOptions] = React.useState<
  //     GetStatusResponse[]
  // >([]);
  // const [requestDate, setRequestDate] = React.useState<
  //     Date[] | null | undefined
  // >(null);

  React.useEffect(() => {
    if (props.exportExcel === true) {
      // ExportGetRegisterLoansMutation.mutate(
      //     valueFilterData! ? valueFilterData! : new Filter()
      // );
      props.setExportExcel(false);
    }
  }, [props.exportExcel]);
  React.useEffect(() => {
    if (props.exportExcel == true) {
      // ExportGetRegisterLoansMutation.mutate(valueFilterData!);
    }
    getInProgressPaymentsMutation.mutate();
  }, []);

  const getInProgressPaymentsMutation = useMutation(GetInProgressPayments, {
    onSuccess: (result: GetPaymentHistoryResponse[]) => {
      if (result) {
        setData(result);
      }
    },
  });

  // let { data, isLoading } = useQuery<DashboardRequest[]>(
  //     "GetUserDashboards",
  //     (): Promise<DashboardRequest[]> => {
  //       return GetUserDashboards();
  //     },
  //     {
  //       onSuccess: (data) => {
  //         if (data != null && data.length > 0) {
  //           setUserDashboards(data);
  //         }
  //       },
  //     }
  //   );
  //   useQuery<GetStatusResponse[]>(LOAN_REQUEST_STATUS, getLoanRequestStatus, {
  //     onSuccess(data) {
  //       setLoanRequestOptions(data);
  //     },
  //   });

  const fillData = (filterData: Filter) => {
    getInProgressPaymentsMutation.mutate();
  };

  //aaded go to stepper
  const dispatch = useDispatch();

  const handelDetail = (key: string) => {
    window.sessionStorage.setItem("key-tablePaymentRequestInfo", key);
    history.push("/settlement/settlementDuring/paymentRequestInfo");
    // if (registrationRequestId && loanRequestStatus == "Assigned") {
    //handleSelectRow(rowIndex);
    //go to nantional code ......... nabayaddd
    // history.push({
    //   pathname: `/loan/Register`,
    //   state: {
    //     id: requestId,
    //     from: "",
    //     pageNumber: currentPaginationInfo.pageNumber!,
    //     clickOnBack: false,
    //   },
    // });
    // }
    // handleSelectRow(rowIndex);
    // const valuesNationalCode = new GetCustomerRegistrationInfoRequest();
    // valuesNationalCode.nationalCode = nationalCode;
    // queryClient.setQueryData(REFRENCE_KEY, requestId);
    // getCustomerRegistrationInfo(valuesNationalCode).then((data) => {
    //   if (data) {
    //     queryClient.setQueryData(HAS_REGISTER_REQUEST, data.hasRegisterRequest);

    //     queryClient.setQueryData(CUSTOMER_INFO, data.customerInfo);
    //     queryClient.setQueryData(LOAN_TEMPLATE_INFOS, data.loanTemplateInfos);
    //     queryClient.setQueryData(
    //       EXISTING_LOANREQUEST,
    //       data.existingLoanRequest
    //     );
    //     // setOpen(false);
    //   }
    // });
  };
  const handleSelectRow = (rowIndex: any) => {
    const cachPageNumber = queryClient.getQueryData(
      TABLE_FILTER_REGISTER
    ) as FilterFinder;
    const filter = new FilterFinder();
    filter.rowNumber = rowIndex;
    // setSelectedRow(rowIndex);
    queryClient.setQueryData(TABLE_FILTER_REGISTER, filter);
  };

  const filter = new Filter();
  return (
    <>
      {props.isShow ? (
        <Box sx={{ flexGrow: 1 }}>
          <Formik
            initialValues={filter}
            onSubmit={(values) => {
              {
              }

              queryClient.setQueryData(TABLE_FILTER, values);
              fillData(values);
            }}
          ></Formik>
        </Box>
      ) : (
        ""
      )}
      <br />

      <div className="cardTableBorder ">
        <TableContainer
          style={{ background: "#fff", direction: "rtl" }}
          className="boxScroll"
        >
          <Table
            stickyHeader
            aria-label="sticky table "
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
              <TableRow
                classes={{ root: classes.select }}
                className={`${classes} borderRight borderLeft`}
                // selected={selectedRow === 0}
              >
                <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight"
                  align="right"
                  style={{ width: "5px" }}
                >
                  ردیف
                </TableCell>
                {columns.map((column) => (
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight nowrapClass"
                    key={column.id}
                    align="right"
                  >
                    {column.label}
                  </TableCell>
                ))}
                {/* <TableCell className="rowTHead colorTitle" align="right">
                  <span className="colorTitle textFont12 fontWeight">
                    وضعیت
                  </span>
                </TableCell> */}
                {/* 
                <TableCell
                  className="rowTHead colorTitle stickyColO"
                  align="right"
                >
                  <MoreHorizIcon
                    scale="scale(1.8) "
                    style={{ color: "#1D4A87" }}
                  />
                </TableCell> */}
              </TableRow>
            </TableHead>
            <div style={{ width: "100%", height: "10px" }}></div>
            <TableBody>
              {data.map((row, rowIndex) => {
                return (
                  <TableRow
                    classes={{ root: classes.select }}
                    className={`${
                      rowIndex % 2 == 0
                        ? "rowTBodyE  borderRight borderLeft"
                        : "rowTBodyO  borderRight borderLeft"
                    }${classes} borderRight borderLeft cursorPointer noWrap`}
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    // key={row.loanRequestId}
                    // selected={selectedRow === rowIndex}
                    onClick={() => handelDetail(row.key)}
                  >
                    <TableCell className="textFont12" style={{ width: "5px" }}>
                      {rowIndex + 1}
                    </TableCell>
                    {columns.map((column) => {
                      const value =
                        row[column.id as keyof GetPaymentHistoryResponse];
                      return (
                        <TableCell
                          className="textFont12 nowrapClass"
                          key={column.id}
                          align="right"
                        >
                          {column.format && column.hasFormat ? (
                            column.format(value)
                          ) : column.id == "status" ? (
                            <b style={{ color: "#EE9D01" }}> {value}</b>
                          ) : (
                            value
                          )}
                        </TableCell>
                      );
                    })}
                    {/* <TableCell className="textFont12" align="right">
                      <b style={{ color: "#EE9D01" }}>در جریان</b>
                    </TableCell>
                     <TableCell className="textFont12" align="right">
                                            {row.description}
                                        </TableCell> */}
                    {/* <TableCell
                      className={
                        rowIndex % 2 == 0 ? " stickyColO   " : " stickyColE  "
                      }
                    >
                      <MoreHorizIcon
                        scale="scale(1.8) "
                      className={
                          row.registrationRequestId &&
                              row.loanRequestStatus == "Assigned"
                              ? "colorTitle"
                              : "colorDesaible1"
                      }

                       onClick={() => handelDetail(row.referenceKey)}
                      />
                    </TableCell> */}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
}
const onKeyDown = (e: any) => {
  e.preventDefault();
};
